const { default: CommonRouter } = require("./commonRoute")
const { default: CommonServerRoute } = require("./commonServerRoute")
try {
    let apiEndpoint = ''
    let commonApi = ''
    let sampleFileApi = ''
    let socketApi = ''
    let chatApi = ''
    let product = {
        app: '',
        gst: '',
        ecom: ''
    }
    const hostname = window.location.hostname
    const localDomain = 'localhost'
    const isLive = window.location.hostname !== localDomain
    const salesDay = new Date().getDay() === 2  //0=Sunday,1=Monday,2=Tuesday,3=Wednesday,4=Thursday,5=Friday,6=Saturday

    const imageFileApi = `https://munim.blr1.digitaloceanspaces.com/app/live/assets/image/banner`
    if (hostname === localDomain) {
        apiEndpoint = `http://${localDomain}:8070/api`
        commonApi = `http://${localDomain}:8070/`
        product = {
            app: `http://${localDomain}:4242`,
            gst: `http://${localDomain}:4242`,
            ecom: `http://${localDomain}:5555`
        }
    } else if (hostname === CommonServerRoute.dev_account) {
        apiEndpoint = 'https://devapi.themunim.com/api'
        commonApi = 'https://devapi.themunim.com/'
        socketApi = 'https://devapi.themunim.com/'
        product = {
            app: 'https://dev.themunim.com',
            gst: 'https://devgst.themunim.com',
            ecom: 'https://devecom.themunim.com'
        }
    } else if (hostname === CommonServerRoute.dev1_account) {
        apiEndpoint = `https://dev1api.themunim.com/api`
        commonApi = `https://dev1api.themunim.com/`
        socketApi = `https://dev1api.themunim.com/`
        product = {
            app: `https://dev1.themunim.com`,
            gst: 'https://devgst.themunim.com',
            ecom: 'https://devecom.themunim.com'
        }
    } else if (hostname === CommonServerRoute.dev2_account) {
        apiEndpoint = `https://dev2api.themunim.com/api`
        commonApi = `https://dev2api.themunim.com/`
        socketApi = `https://dev2api.themunim.com/`
        product = {
            app: `https://dev2.themunim.com`,
            gst: 'https://devgst.themunim.com',
            ecom: 'https://devecom.themunim.com'
        }
    } else if (hostname === CommonServerRoute.stage_account) {
        apiEndpoint = 'https://stageapi.themunim.com/api'
        commonApi = 'https://stageapi.themunim.com/'
        socketApi = 'https://stageapi.themunim.com/'
        product = {
            app: 'https://stage.themunim.com',
            gst: 'https://stagegst.themunim.com'
        }
    } else if (hostname === CommonServerRoute.qa_account) {
        apiEndpoint = 'https://qaapi.themunim.com/api'
        commonApi = 'https://qaapi.themunim.com/'
        socketApi = 'https://qaapi.themunim.com/'
        product = {
            app: 'https://qa.themunim.com',
            gst: 'https://qagst.themunim.com',
            // gst: 'https://preprodgst.themunim.com'
        }
    } else if (hostname === CommonServerRoute.live_account) {
        apiEndpoint = 'https://api.themunim.com/api'
        commonApi = 'https://api.themunim.com/'
        socketApi = 'https://api.themunim.com/'
        product = {
            app: 'https://app.themunim.com',
            gst: 'https://gst.themunim.com',
            ecom: 'https://ecommerce.themunim.com'
        }
    } else if (!myParam) {
        if (window.location.host == CommonServerRoute.live_account) {
            apiEndpoint = 'https://api.themunim.com/api'
            commonApi = 'https://api.themunim.com/'
            socketApi = 'https://api.themunim.com/'
            product = {
                app: 'https://app.themunim.com',
                gst: 'https://gst.themunim.com',
                ecom: 'https://ecommerce.themunim.com'
            }
        } else {
            apiEndpoint = 'https://stageapi.themunim.com/api'
            commonApi = 'https://stageapi.themunim.com/'
            socketApi = 'https://stageapi.themunim.com/'
            product = {
                app: 'https://stage.themunim.com',
                gst: 'https://stagegst.themunim.com'
            }
        }
    }
    module.exports = {
        apiEndpoint,
        commonApi,
        sampleFileApi,
        socketApi,
        chatApi,
        product,
        localDomain,
        isLive,
        imageFileApi,
        salesDay
    }
} catch (error) {
    window.location.href = CommonRouter.log_in
}